import axios from 'axios';
import { getApiEndpoint } from './utilities';
export default {

    checkStatus(id, arrivalDate, cb, errorCb) {
        axios.get(getApiEndpoint() + 'api/voucher/status/' + id + '/' + arrivalDate)
            .then(response => {
                cb(response.data);
            })
            .catch(response => {
                errorCb(response);
            });

    },
    getDetail(id, cb) {
        axios.get(getApiEndpoint() + 'api/voucher/detail/' + id)
            .then(response => {
                cb(response.data);
            });
    }
}

